import { store } from 'Store/store.index';
import { /* USER_SIGN_IN_FAILED, */ USER_SIGN_IN_SUCCESS } from 'Store/constants';
import {
  DOC_OPEN_SUCCESS,
  DOC_OPEN_FAILED,
  DOC_MODIFIED,
  DOC_BEFORE_OPEN,
  USER_SIGN_IN, 
  USER_MESSAGE_CALLBACK,
  DOC_ACTIVATE,
  DOC_SAVED,
  LABEL_TOOL_CANCELED,
  //USER_SIGN_OUT

} from './constants'
import _throttle from "lodash/throttle";
export default class EventManage{
  constructor(fnMap){
    this.fnMap = fnMap;
    this.eventMap = {};

    this.init = this.init.bind(this);
    this.addListenMap = this.addListenMap.bind(this);
    this.addViewerEventListener = this.addViewerEventListener.bind(this);

    this.onThrottle_DocModified = this.onThrottle_DocModified.bind(this);
    this.fn_Throttle_DocModified = this.onThrottle_DocModified();
  }

  init(){
    // add listener __dispatchEvent=> subscribe
    this.fnMap['subscribe'] = ({ method, data, id, resolve, listener })=>{
      let {event, cb} = data;
      this.eventMap[event] = {id, resolve, method, listener, eventName:event, cb};
    }

    this.addListenMap(USER_SIGN_IN_SUCCESS, USER_SIGN_IN); // user
    this.addListenMap(DOC_OPEN_SUCCESS, DOC_OPEN_SUCCESS); // doc
    this.addListenMap(DOC_OPEN_FAILED, DOC_OPEN_FAILED);
    this.addListenMap(DOC_MODIFIED, DOC_MODIFIED);
    this.addListenMap(DOC_BEFORE_OPEN, DOC_BEFORE_OPEN);
    this.addListenMap(DOC_ACTIVATE, DOC_ACTIVATE);
    this.addListenMap(DOC_SAVED, DOC_SAVED);
    this.addListenMap(USER_MESSAGE_CALLBACK, USER_MESSAGE_CALLBACK);
    this.addListenMap(LABEL_TOOL_CANCELED, LABEL_TOOL_CANCELED); // label
    // listen on viewer, and then emit event to ai-plugin
    this.addViewerEventListener();
  }

  onThrottle_DocModified(){ 
    //this.fn_flag++
    return _throttle(() => {
      store.appStore.doNoticeMessage(DOC_MODIFIED)
      //let _fn_flag = this.fn_flag;
      //let _time = new Date().format('yyyy-MM-dd hh:mm:ss.S');
      
    }, 5000, {
      leading: true,
      trailing: true
    })
  }
  addViewerEventListener(){

    let Events     = UIExtension.PDFViewCtrl.Events;
    let DataEvents = UIExtension.PDFViewCtrl.PDF.DataEvents;
    window.pdfui.addViewerEventListener(Events.beforeOpenFile, function(){
      store.appStore.doNoticeMessage(DOC_BEFORE_OPEN)
    })
    window.pdfui.addViewerEventListener(Events.openFileSuccess, function(){
      store.appStore.doNoticeMessage(DOC_OPEN_SUCCESS)
    })
    window.pdfui.addViewerEventListener(Events.openFileFailed, function(){
      store.appStore.doNoticeMessage(DOC_OPEN_FAILED)
    })
    window.pdfui.addViewerEventListener(DataEvents.docModified, this.fn_Throttle_DocModified)
    // window.pdfui.addViewerEventListener(DataEvents.docModified, function(){
    //   store.appStore.doNoticeMessage(DOC_MODIFIED)
    // })

  }
  addListenMap(onlineEvent, aiEvent){
    store.appStore.addAppEventListener(onlineEvent, (data)=>{
      let event = this.eventMap[aiEvent]
      if(!event)return;
      let result = {ret:0, name: aiEvent};
      !!data && (result['data'] = data);
      event.listener(result)
    })
  }
}